import React from "react";
import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import SEO from "../../hooks/SEO";
import PageBanner from "../../components/PageBanner";
import TeamSection from "../../components/Team/Team";
import CTASection from "../../components/CTASection";
import { seoContent, siteMeta } from "../../data/mockData";

const TeamPage = () => (
  <>
    <SEO
      title={seoContent.team.title}
      description={seoContent.team.description}
      name={siteMeta.name}
      type="website"
    />
    <PageBanner
      title="Leadership and Team"
      description="Leadership and representative roles associated with Refwa."
      image={siteMeta.bannerImage}
      breadcrumbs={[{ label: "Team" }]}
    />

    <Box className="site-section">
      <Container>
        <Paper
          sx={{
            p: { xs: 3, md: 3.8 },
            mb: { xs: 4.5, md: 5.5 },
            border: "1px solid var(--color-border)",
            boxShadow: "var(--shadow-card)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 4 }} sx={{ width: "100%", m: 0 }}>
            <Grid item xs={12} lg={7}>
              <Box className="eyebrow">Representation</Box>
              <Typography variant="h3" sx={{ mt: 1.6, maxWidth: 650 }}>
                Leadership Overview
              </Typography>
            </Grid>
            <Grid item xs={12} lg={5}>
              <Stack spacing={1.3}>
                <Typography variant="body2" color="text.secondary">
                  Refwa's leadership and representative profiles are presented in a concise format consistent with the information shown on the site.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  This page is intended to reflect governance, representation, and commercial visibility without extending beyond the available information.
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
        <TeamSection />
      </Container>
    </Box>

    <CTASection
      title="Contact the Team"
      description="For direct correspondence, please use Refwa's listed contact details."
    />
  </>
);

export default TeamPage;
